// Library methods
import { useTranslation } from "react-i18next";

// MUI Components
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import DefaultModal from "../DefaultModal";

// Styles
import {
  ModalCustomCancel,
  ModalCustomConfirm,
} from "../../../styles/muiStylesHelper";

const ClinicModeModal = ({ open, onClose, onConfirm, onCancel }) => {
  // internationalization
  const { t } = useTranslation();

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      title={t("word_leave_admin")}
      maxWidth="xs"
    >
      <Grid display="flex" p="20px" gap="20px" justifyContent="center">
        <Button variant="text" sx={ModalCustomCancel} onClick={onCancel}>
          {t("button_cancel")}
        </Button>
        <Button variant="outlined" sx={ModalCustomConfirm} onClick={onConfirm}>
          {t("word_proceed")}
        </Button>
      </Grid>
    </DefaultModal>
  );
};

export default ClinicModeModal;
